// Hooks
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useTabNavigation } from 'src/redux/slices/navigation/hooks'
import { getProject } from 'src/redux/slices/project/endpoints'
import {
  mutationFixedCacheKeys,
  sendGroupData
} from 'src/redux/slices/umibuilder/endpoints'
import {
  selectGroupData,
  selectUmiBuilderFromCloud
} from 'src/redux/slices/umibuilder/selectors'

import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'

import PrimaryFieldGroup from '../components/PrimaryFieldGroup'

///// Component
const OrganizePage: React.FC = () => {
  const { goToTab } = useTabNavigation()
  const { data: project, isLoading: isLoadingProject } = getProject.useQuery('')
  const fromCloud = useSelector(selectUmiBuilderFromCloud)

  const [trigger, { isLoading: isSendingGroupData }] = sendGroupData.useMutation({
    fixedCacheKey: mutationFixedCacheKeys.sendGroupData,
  })
  const allGroups = useSelector(selectGroupData)

  useEffect(() => {
    trigger({ groups: allGroups, fromCloud, project_id: project?.id })
  }, [allGroups, project, fromCloud])

  return (
    <Grid container justifyContent='flex-start' alignItems='center' spacing={3} direction='column'>
      <Button
        disabled={isSendingGroupData}
        onClick={() => goToTab('assign')}
        variant='contained'
        color='primary'
      >
        Confirm
      </Button>
      {allGroups?.map((primaryGroup) => (
        <PrimaryFieldGroup primaryGroup={primaryGroup} key={primaryGroup.field} />
      ))}
    </Grid>
  )
}

export default OrganizePage
